if (typeof window.CustomProductRecommendations === 'undefined') {
  function addToCart(form) {
    const variantId = form.querySelector('input[name="id"]').value;
    const product_id = form.querySelector('input[name="id"]').dataset.productId;
    let properties = {};
    const collectionsInput = form.querySelector('input[name="properties[_collections]"]');
    if (collectionsInput && collectionsInput.value) {
      properties['_collections'] = collectionsInput.value;
    }

    const items = [
      {
        id: variantId,
        quantity: 1
      }
    ];
    if (Object.keys(properties).length > 0) {
      items[0].properties = properties;
    }

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({items})
    })
      .then(data => {
        return data.json();
      })
      .then(json => {
        if (json.items && json.items[0]) {
          const addedItem = json.items[0];
          // Klaviyo added to cart event
          window._learnq = window._learnq || [];
          const rawSrc = addedItem.image || '';
          const imageSrc = rawSrc ? 'https:' + rawSrc.replace(/(\.[^.]*)$/, '_grande$1') : '';
          const klaviyoItem = {
            Name: addedItem.title || addedItem.product_title || '',
            ProductID: addedItem.product_id ? addedItem.product_id : '',
            Categories: addedItem.collections || [],
            ImageURL: imageSrc,
            URL: `${window.theme.shopSecureUrl || window.location.origin}${addedItem.url ? addedItem.url.split('?')[0] : ''}`,
            Brand: addedItem.vendor || '',
            Price: slate.Currency.formatMoney(addedItem.price),
            $value: parseFloat(slate.Currency.formatMoney(addedItem.price, "{{amount}}")),
            CompareAtPrice: addedItem.compare_price ? slate.Currency.formatMoney(addedItem.compare_price) : '',
          };
          window._learnq.push(['track', 'Added to Cart', klaviyoItem]);
        }
        if(!json.status){
          if(window.location.pathname === '/cart'){
            theme.cartPage.updateCartItemsEvent();
            window.theme.cartPage.refreshCart();
            setTimeout(() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 500);
            // window.location.reload();
            // return;
          }
          else {
            theme.sideCart.updateCartItemsEvent();
            window.theme.sideCart.refreshCart();
            if (window.theme.settings.enable_bopis) {
              // window.openCartPopup();
              let size;
              if(json.items[0].options_with_values && json.items[0].options_with_values.length){
                let sizeOption = json.items[0].options_with_values.find(option => option.name.toLowerCase() === 'size');
                if(sizeOption){
                  size = sizeOption.value;
                }
              }
              updateCartPopup({
                title: json.items[0].product_title,
                image: json.items[0].image,
                quantity: 1,
                size:size,
                id:product_id,
                vId: variantId
              });
            } else {
              theme.sideCart.openDrawer();
            }
          }
        }
      })
      .catch(err => {
        console.error(err);
        window.location.href = window.Shopify.routes.root + 'cart'
      });
  }
  window.CustomProductRecommendations = class CustomProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.waitOnReady();
      //let moneyFormat = window.Currency.moneyFormats[window.Shopify.currency.active].money_format || null;
      //moneyFormat = moneyFormat.replace(window.theme.currentCurrencySymbol,'');
      //this.moneyFormat = moneyFormat;
    }
    // Element functionality written in here
    waitOnReady() {
      if( this.shadowRoot && window.xgenCss ) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = window.xgenCss;
        this.shadowRoot.appendChild(link);
      }
      if (this.shadowRoot && this.shadowRoot.querySelector('form[action*="cart/add"] input[name="id"]')) {
        setTimeout(() => {
          this.onReady();
        }, 0);
      } else {
        setTimeout(() => {
          this.waitOnReady();
        }, 1000);
      }
    }
    formatMoney(price) {
      const formatted = slate.Currency.formatMoney(price, window.theme.moneyFormat).replace(/<\/?[^>]+(>|$)/g, "");
      const symbol = window.theme.currentCurrencySymbol;
      if (formatted.includes(symbol)) {
        return formatted.replace(symbol, `<em class="currency-symbol">${symbol}</em>`);
      }
      return `<em class="currency-symbol">${symbol}</em>${slate.Currency.removeCurrencySymbol(formatted)}`;
    }
    updateProductPrice(productCard, currentVariant) {
      const pricingWrap = productCard.querySelector('.xgen-product-card__price-container');
      if( pricingWrap && currentVariant.price ) {
        let pricingHTML = `<p class="xgen-product-card__price xgen-text-[length:var(--price-size)] apply-font-body xgen-apply-font-body xgen-not-italic xgen-font-bold xgen-text-[var(--price-color)]">
          ${this.formatMoney(currentVariant.price)}
        </p>`

        if( currentVariant.compareAtPrice > currentVariant.price ) {
          pricingHTML = `<p class="xgen-product-card__compare-price xgen-text-[length:var(--compare-size)] apply-font-body xgen-apply-font-body xgen-not-italic xgen-font-normal xgen-line-through xgen-text-[var(--compare-color)]">
            ${this.formatMoney(currentVariant.compareAtPrice)}
          </p>` + pricingHTML

          pricingHTML += `<span class="product-per-off show-per-off-mobile show-per-off-desktop">(-${Math.round(((currentVariant.compareAtPrice - currentVariant.price) * 100) / currentVariant.compareAtPrice)}%)</span>`
        }

        pricingWrap.innerHTML = pricingHTML
      }
      pricingWrap.classList.add('visible')
    }

    handleProductCard(productCard, filteredProducts, repeated = false) {
      const _this = this;
      const variantIdOriginalInput = productCard.querySelector('input[name="id"].xgen-product-variant-id');
      if(variantIdOriginalInput && filteredProducts.length) {
        const variantId = variantIdOriginalInput.value;
        const form = productCard.querySelector('form[action*="cart/add"]');
        const product = filteredProducts.find(product => product.variants.find(variant => variant.id === variantId));
        // hack required due to xgen updating its input to default variant id
        variantIdOriginalInput.name = 'variant_id';
        const variantIdInput = document.createElement('input');
        variantIdInput.name = 'id';
        variantIdInput.type = 'hidden';
        variantIdInput.value = variantId;
        if(product){
          variantIdInput.dataset.productId = product.id;
          if (product.collections && product.collections.length) {
            let collectionsInput = form.querySelector('input[name="properties[_collections]"]');
            if (!collectionsInput) {
              collectionsInput = document.createElement('input');
              collectionsInput.name = 'properties[_collections]';
              collectionsInput.type = 'hidden';
              form.appendChild(collectionsInput);
            }
            collectionsInput.value = [...product.collections].sort().join(',');
          }
        }
        form.appendChild(variantIdInput);

        if( !product ) {
          return;
        };

        const isOnlyInStore = product.tags && product.tags.some(tag => typeof tag === 'string' && tag.trim().toLowerCase() === 'in-store');
        if (isOnlyInStore && form) {
          form.style.display = 'none';
        }

        let currentVariant = product.variants ? product.variants.find(variant => variant.id === variantId) : null;

        const xGenOptions = productCard.querySelectorAll(
          '.xgen-product-card__options-selector button.xgen-block-option'
        );
        if (xGenOptions.length) {
          xGenOptions.forEach(function(xGenOption) {
            const xGenOptionName = xGenOption.innerText.trim();
            if (product) {
              const option = product.variants.find(variant => variant.title === xGenOptionName);
              if (option && option.available) {
                xGenOption.dataset.variantId = option.id;
                if (option.id === variantId) {
                  xGenOption.classList.add('active');
                }
                xGenOption.addEventListener('click', function(e) {
                  e.preventDefault();
                  variantIdInput.value = option.id;
                  xGenOptions.forEach(function(xGenOptionInner) {
                    xGenOptionInner.classList.remove('active');
                  });
                  xGenOption.classList.add('active');
                  currentVariant = option;
                  _this.updateProductPrice(productCard, currentVariant);
                });
              } else {
                xGenOption.disabled = true;
                xGenOption.classList.add('disabled');
              }
            }
          });
        }
        _this.updateProductPrice(productCard, currentVariant);
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          addToCart(form);
          return false;
        });

        form.querySelector('button.xgen-product-card__add-to-cart').addEventListener('click', function(e) {
          e.preventDefault();
          addToCart(form);
          return false;
        });
      } else if(!repeated) {
        setTimeout(() => {
          _this.handleProductCard(productCard, filteredProducts, true);
        }, 100);
      }
    }

    async onReady() {
      const _this = this;
      const productCards = this.shadowRoot.querySelectorAll('.xgen-product-card');
      const variantIds = [];
      Array.from(productCards).forEach(productCard => {
        if(productCard.querySelector('input[name="id"].xgen-product-variant-id')) variantIds.push(productCard.querySelector('input[name="id"].xgen-product-variant-id').value);
      });
      const PRODUCTS_STORAGE_KEY = 'graphql_all_products_' + Shopify.country;
      const allProducts = JSON.parse(sessionStorage.getItem(PRODUCTS_STORAGE_KEY) || '[]');

      let filteredProducts = allProducts.length
        ? allProducts.filter(product => {
            return (
              product.variants &&
              product.variants.find(variant => variant.id === variantIds.find(id => id === variant.id))
            );
          })
        : [];

      const hasMissingProducts = filteredProducts.length !== variantIds.length;
      const hasMissingData = filteredProducts.some(p => !Array.isArray(p.tags) || !Array.isArray(p.collections));

      if (hasMissingProducts || hasMissingData) {
        const variantIdsToFetch = hasMissingData
          ? variantIds
          : variantIds.filter(id => !filteredProducts.find(product => product.variants.find(variant => variant.id === id)));
        if (hasMissingData) {
          filteredProducts = filteredProducts.filter(p => Array.isArray(p.tags) && Array.isArray(p.collections));
        }
        const res = await fetch(`https://${window.Shopify.shop}/api/2025-10/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/graphql',
            'X-Shopify-Storefront-Access-Token': window.theme.storefrontAPIToken
          },
          body: `
            query getProducts @inContext(country: ${Shopify.country}) {
              ${variantIdsToFetch
                .map(id => {
                  if( !id ) return '';
                  return `p_${id}: node(id: "gid://shopify/ProductVariant/${id}") {
                  id
                  ... on ProductVariant {
                    id
                    product {
                      id
                      tags
                      collections(first: 250) {
                        edges {
                          node {
                            handle
                          }
                        }
                      }
                      variants(first: 250) {
                        edges {
                          node {
                            id
                            title
                            availableForSale
                            price {
                              amount
                            }
                            compareAtPrice {
                              amount
                            }
                          }
                        }
                      }
                    }
                  }
                }`;
                })
                .join('\n')}

            }
          `
        });
        const resData = await res.json();
        // A GraphQL error response (throttled / invalid token) carries no
        // `data` — Object.keys(null) threw an uncaught rejection and the
        // widget died. Treat it as "no products resolved" instead.
        const resNodes = (resData && resData.data) || {};
        let stillMissingVariantIds = []
        Object.keys(resNodes).forEach(key => {
          const product = resNodes[key]?.product;
          if(product){
            filteredProducts.push({
              id: product.id.split('/').pop(),
              tags: product.tags || [],
              collections: product.collections && product.collections.edges ? product.collections.edges.map(c => c.node.handle) : [],
              variants: product.variants.edges.map(variant => ({
                id: variant.node.id.split('/').pop(),
                title: variant.node.title,
                available: variant.node.availableForSale,
                price: variant.node.price ? variant.node.price.amount * 100 : null,
                compareAtPrice: variant.node.compareAtPrice ? variant.node.compareAtPrice.amount * 100 : null
              })) || []
            });
          } else {
            stillMissingVariantIds.push(key.split('_')[1]);
          }
        });
        stillMissingVariantIds.forEach(id => {
          productCards.find(productCard => productCard?.href?.indexOf(id) !== -1)?.classList.add('xgen-product-card--api-error');
        });
        productCards.forEach((productCard) => {
          _this.handleProductCard(productCard, filteredProducts, false);
        });



        //if(stillMissingVariantIds.length){
        //  const stillMissingHandles = stillMissingVariantIds.map(id => {
        //    const input = Array.from(productCards).find(productCard => productCard?.href?.indexOf(id) !== -1);
        //    const productCard = input?.closest('.xgen-product-card');
        //    return productCard?.href.replace(/.*products\/(.*)\?.*/g, '$1');
        //  });
        //  if( !stillMissingHandles.length ) return;
        //  const resHandles = await fetch(`https://${window.Shopify.shop}/api/2025-10/graphql.json`, {
        //    method: 'POST',
        //    headers: {
        //      'Content-Type': 'application/graphql',
        //      'X-Shopify-Storefront-Access-Token': window.theme.storefrontAPIToken
        //    },
        //    body: `
        //      query getProducts {
        //        ${stillMissingHandles.map((handle, index) => `p_${index}: product(handle: "${handle}") {
        //          id
        //          variants(first: 250) {
        //            edges {
        //              node {
        //                id
        //                title
        //                availableForSale
        //                price {
        //                  amount
        //                }
        //                compareAtPrice {
        //                  amount
        //                }
        //              }
        //            }
        //          }
        //        }`).join('\n')}
        //      }
        //    `
        //  });
        //  const resHandlesData = await resHandles.json();

        //  const newFilteredProducts = [];
        //  Object.keys(resHandlesData.data).forEach(key => {
        //    const product = resHandlesData.data[key]?.product;
        //    if(product){
        //      newFilteredProducts.push({
        //        id: product.id.split('/').pop(),
        //        variants: product.variants.edges.map(variant => ({
        //          id: variant.node.id.split('/').pop(),
        //          title: variant.node.title,
        //          available: variant.node.availableForSale,
        //          price: variant.node.price ? variant.node.price.amount * 100 : null,
        //          compareAtPrice: variant.node.compareAtPrice ? variant.node.compareAtPrice.amount * 100 : null
        //        })) || []
        //      });
        //    } else {
        //      productCards.find(productCard => productCard?.href?.indexOf(key.split('_')[1]) !== -1)?.classList.add('xgen-product-card--api-error');

        //    }
        //  });
        //  productCards.forEach((productCard) => {
        //    _this.handleProductCard(productCard, newFilteredProducts, false);
        //  });
        //}
      } else {
        productCards.forEach((productCard) => {
          _this.handleProductCard(productCard, filteredProducts, false);
        });
      }


    }
  }
  customElements.define('x-product-recommendations', window.CustomProductRecommendations);
}
